import type { LocaleKey } from './context';
import feedbackEnUS from './locales/components/feedback/en-US.json';
import feedbackZhCN from './locales/components/feedback/zh-CN.json';
import feedbackZhHK from './locales/components/feedback/zh-HK.json';
import filePreviewEnUS from './locales/components/file-preview/en-US.json';
import filePreviewZhCN from './locales/components/file-preview/zh-CN.json';
import filePreviewZhHK from './locales/components/file-preview/zh-HK.json';
import richTextEnUS from './locales/components/rich-text/en-US.json';
import richTextZhCN from './locales/components/rich-text/zh-CN.json';
import richTextZhHK from './locales/components/rich-text/zh-HK.json';

export type Locale = LocaleKey;

const dictionaries: Record<Locale, Record<string, string>> = {
  'zh-CN': { ...feedbackZhCN, ...filePreviewZhCN, ...richTextZhCN },
  'zh-HK': { ...feedbackZhHK, ...filePreviewZhHK, ...richTextZhHK },
  'en-US': { ...feedbackEnUS, ...filePreviewEnUS, ...richTextEnUS },
};

/** 组件显式语言参数与 admin 语言资源共用词条，不引入预览或业务 mock 语言包。 */
export function getMessages(locale: Locale): Record<string, string> {
  return dictionaries[locale];
}
